<!-- <div class="col-xs-12 col-md-2 col-lg-2 col-sm-6  web-tr rmbrsmnt-spprtserv hidden-xs">
    <a href="javascript:void(0)" (click)="navigateToResourcePage()" title="Back to dashboard">
        <img src="../../../../assets/icons/chevronIconWhite.svg" alt="" class="chevron-left">
        Back to coding education &amp; reimbursement support</a>
</div> -->
<div class="col">
    <div class="col-8 float-right web-tr rmbrsmnt-spprtserv hidden-xs">
        <a (click)="navigateToResourcePage()" title="Back to dashboard">
            <img src="../../../../assets/icons/{{baseSiteId}}/chevron-left_green.svg" alt="" class="chevron-left">
            Back to coding education reimbursement support</a>
    </div>
</div>
<div class="row ml-0 mr-0" id="leftCont-rightNav">
    <section id="left-section" class="col-lg-8 col-md-8">
        <div class="row">
            <div class="col">
                <div class="content border-bottom-1" [innerHTML]="cmsResponseBodyDesc"></div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="content border-bottom-1" [innerHTML]="cmsResponseCallSupportContent"></div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="content border-bottom-1">
                    <div [innerHTML]="cmsResponseEmailFaxTitle"></div>
                    <ul class="li-imgtext">
                        <li>
                            <img *ngIf="reimbursePdfDetailsObj?.document?.mime == 'application/pdf'"
                                src="../../../../assets/icons/{{baseSiteId}}/pdf.svg" alt="pdf">
                            <a (click)="downloadPdf(reimbursePdfDetailsObj?.document?.downloadUrl)" name="pdf">
                                {{reimbursePdfDetailsObj?.document?.name}}
                            </a>
                        </li>
                        <li>
                            <img gIf="fluInquiryPdfDetailsObj?.document?.mime == 'application/pdf'"
                                src="../../../../assets/icons/{{baseSiteId}}/pdf.svg" alt="pdf">
                            <a (click)="downloadPdf(fluInquiryPdfDetailsObj?.document?.downloadUrl)" name="pdf">
                                {{fluInquiryPdfDetailsObj?.document?.name}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div id="reimbrsmnt-cntctOnline" class="coding-reimbursement resupport-service">
            <div class="row ">
                <div class="col">
                    <h3 class="blue-sec mt-4">Contact us online</h3>
                    <p class="grey-sec" *ngIf="!detailsSuccessfullySubmitted">Fill out the following online form,
                        including some specifics about your
                        situation and how we can help you.</p>
                    <p class="grey-sec" *ngIf="detailsSuccessfullySubmitted">
                        <img src="../../../../assets/icons/confirmation-positive-green.png">
                        Your message has been sent and the support team will contact you.
                    </p>
                </div>
            </div>
            <form *ngIf="!detailsSuccessfullySubmitted" id="sanofiContactOnlineForm" [formGroup]="contactOnlineForm"
                (ngSubmit)="onFormSubmit()">
                <div class="row">
                    <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6 p-rytlft Fields-container">
                        <label class="Fields-label">Location name</label>
                        <input id="locationName" formControlName="locationName" type="text" class="Fields-input">
                        <!-- <span class="hide" role="alert" aria-live="assertive" *ngIf="(contactOnlineForm.controls.locationName?.touched && contactOnlineForm.controls.locationName?.value && !contactOnlineForm.controls.locationName?.valid)">This field accepts alphanumeric
                                characters and spaces as well.</span>  -->
                        <span class="defaultMessage" role="alert"
                            *ngIf="(contactOnlineForm.controls.locationName?.touched || submitted) && contactOnlineForm.controls.locationName?.errors?.required"
                            aria-live="assertive">This
                            field is required</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6  p-rytlft Fields-container">
                        <label class="Fields-label">Contact name</label>
                        <input id="contactName" formControlName="contactName" type="text" class="Fields-input">
                        <span class="defaultMessage" role="alert" aria-live="assertive"
                            *ngIf="(contactOnlineForm.controls.contactName?.touched && contactOnlineForm.controls.contactName?.value && !contactOnlineForm.controls.contactName?.valid)">Please
                            Enter Valid Contact name.</span>
                        <span class="defaultMessage" role="alert" aria-live="assertive"
                            *ngIf="(contactOnlineForm.controls.contactName?.touched || submitted) && contactOnlineForm.controls.contactName?.errors?.required">This
                            field is required</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6 p-rytlft Fields-container">
                        <label class="Fields-label">Position or title <span class="optional">(Optional)</span></label>
                        <input id="title" formControlName="title" type="text" class="Fields-input field-optional">
                        <span class="defaultMessage"
                            *ngIf="(contactOnlineForm.controls.title?.touched && contactOnlineForm.controls.title?.value && !contactOnlineForm.controls.title?.valid)">This
                            field accepts alphanumeric characters and spaces as well.</span>
                        <span class="defaultMessage"
                            *ngIf="(contactOnlineForm.controls.title?.touched || submitted) && contactOnlineForm.controls.title?.errors?.required"></span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6  p-rytlft Fields-container">
                        <label class="Fields-label">Street address</label>
                        <input id="streetAddress" formControlName="streetAddress" type="text" class="Fields-input">
                        <!-- <span class="hide" role="alert" aria-live="assertive" *ngIf="(contactOnlineForm.controls.locationName?.touched && contactOnlineForm.controls.locationName?.value && !contactOnlineForm.controls.locationName?.valid)">This field accepts alphanumeric
                                characters and spaces as well.</span>  -->
                        <span class="defaultMessage" role="alert" aria-live="assertive"
                            *ngIf="(contactOnlineForm.controls.streetAddress?.touched || submitted) && contactOnlineForm.controls.streetAddress?.errors?.required">This
                            field is required</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6  p-rytlft Fields-container">
                        <label class="Fields-label">City, state, zipcode</label>
                        <input id="cityStateZipcode" formControlName="cityStateZipcode" type="text"
                            class="Fields-input">
                        <!-- <span class="hide" role="alert" aria-live="assertive" *ngIf="(contactOnlineForm.controls.cityStateZipcode?.touched && contactOnlineForm.controls.cityStateZipcode?.value && !contactOnlineForm.controls.cityStateZipcode?.valid)">This field accepts alphanumeric
                                characters and spaces as well.</span>  -->
                        <span class="defaultMessage" role="alert" aria-live="assertive"
                            *ngIf="(contactOnlineForm.controls.cityStateZipcode?.touched || submitted) && contactOnlineForm.controls.cityStateZipcode?.errors?.required">This
                            field is required</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6 p-rytlft Fields-container">
                        <label class="Fields-label">Telephone</label>
                        <input id="telephone" formControlName="telephone" type="text"
                            class="Fields-input phone-no-valid" onkeypress="return /[0-9]/.test(event.key)"
                            (keyup)="formatPhoneNumber($event)" (paste)="formatPhoneNumber($event)" maxlength="12">
                        <!-- <span class="hide" role="alert" aria-live="assertive" *ngIf="(contactOnlineForm.controls.locationName?.touched && contactOnlineForm.controls.locationName?.value && !contactOnlineForm.controls.locationName?.valid)">This field accepts numeric 10 digit phone
                                number </span>  -->
                        <span class="defaultMessage" role="alert" aria-live="assertive"
                            *ngIf="contactOnlineForm.controls.telephone?.value && !contactOnlineForm.controls.telephone?.valid">This
                            field accepts numeric 10 digit phone number</span>
                        <span class="defaultMessage" role="alert" aria-live="assertive"
                            *ngIf="(contactOnlineForm.controls.telephone?.touched || submitted) && contactOnlineForm.controls.telephone?.errors?.required">This
                            field is required</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6  p-rytlft Fields-container">
                        <label class="Fields-label">Fax <span class="optional">(Optional)</span></label>
                        <input id="fax" formControlName="fax" onkeypress="return /[0-9]/.test(event.key)"
                            (paste)="formatFaxNumber($event)" (change)="formatFaxNumber($event)" type="text"
                            class="Fields-input field-optional phone-no-valid" maxlength="12">
                        <span class="defaultMessage" role="alert" aria-live="assertive"
                            *ngIf="contactOnlineForm.controls.fax?.value && !contactOnlineForm.controls.fax?.valid">This
                            field accepts numeric 10 digit fax number</span>
                        <!-- <span class="hide"
                            *ngIf="(contactOnlineForm.controls.fax?.touched || submitted) && contactOnlineForm.controls.fax?.errors?.required">This
                            field is required</span> -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6 p-rytlft Fields-container">
                        <label class="Fields-label">Email address</label>
                        <input id="emailAddress" formControlName="emailAddress" data-valid="valid_mail" type="text"
                            class="Fields-input">
                        <span class="defaultMessage"
                            *ngIf="(contactOnlineForm.controls.emailAddress?.touched && contactOnlineForm.controls.emailAddress?.value && !contactOnlineForm.controls.emailAddress?.valid)">Invalid
                            email address</span>
                        <span class="defaultMessage"
                            *ngIf="(contactOnlineForm.controls.emailAddress?.touched || submitted) && contactOnlineForm.controls.emailAddress?.errors?.required">This
                            field is required</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-10 p-rytlft Fields-container">
                        <label class="Fields-label">Your question</label>
                        <textarea id="comment" formControlName="question"
                            placeholder="Please give us a detailed question you would like answered."
                            class="mt-0 Fields-textarea"></textarea>
                        <span class="defaultMessage mb1"
                            *ngIf="(contactOnlineForm.controls.question?.touched || submitted) && contactOnlineForm.controls.question?.errors?.required">This
                            field is required</span>
                    </div>
                </div>
                <div class="row ml-1 mt-5">
                    <button type="submit" id="contactonline" class="btn-primary RSService-btn "
                        data-di-id="#contactonline">Submit request</button>
                </div>

                <div>
                    <input type="hidden" name="CSRFToken" value="f9b7e60a-e21f-4831-9c18-a735da5f7e05">
                </div>
            </form>

        </div>
    </section>
    <section id="right-section" class="col-lg-4 col-md-4">

    </section>
</div>